
import { Margin } from "@/utils/documents/margin";
import Vue from "vue";
export default Vue.extend({
	props: {
		value: {
			type: Object as ()=>Margin,
			required: true
		},
		title: String
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
